function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { CardBuilder } from "./Helpers/CardBuilder";
import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
import { PledgeUtils } from "./Helpers/PledgeUtils";
import { MissionTripApiService } from "./Services/MissionTripApiService";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { TextFormatter } from "./Helpers/TextFormatter";
export var MppMyMissionTrips = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyMissionTrips, _ComponentBase);

  var _super = _createSuper(MppMyMissionTrips);

  function MppMyMissionTrips() {
    _classCallCheck(this, MppMyMissionTrips);

    return _super.call(this);
  }

  _createClass(MppMyMissionTrips, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (!!this._$resultsContainer) {
        this.loadAttributes();
        this.GetMyMissionTrips();
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.missionTripCampaignType = this.getAttribute("missiontripcampaigntypeid") || 2; // Default to mission trip if id doesn't exist
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppMyMissionTrips.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; // Load initial values of tag attributes:

                this.loadAttributes(); // Root Html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper" id="myMissionTripsWrapper" style="display: none;"></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myMissionTripsNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div class="resultsContainer mppw-card-row-container" id="resultsContainer"></div></div>` ;
                this._$myMissionTripsWrapper = this._root.querySelector("#myMissionTripsWrapper");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._missionTripsService = new MissionTripApiService(); // Try logging in user

                _context.next = 15;
                return this.TryLoginUser();

              case 15:
                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "TryLoginUser",
    value: function () {
      var _TryLoginUser = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return UserService.GetCurrentUser().then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(userInfo) {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _this2._$loginButtonContainer.style.display = "none";
                            _this2._$myMissionTripsWrapper.style.display = "";
                            _context2.next = 4;
                            return _this2.GetMyMissionTrips();

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }(), function () {
                  _this2._$myMissionTripsWrapper.style.display = "none";
                  _this2._$loginButtonContainer.style.display = "";
                  _this2._$loadingContainer.style.display = "none";
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function TryLoginUser() {
        return _TryLoginUser.apply(this, arguments);
      }

      return TryLoginUser;
    }()
  }, {
    key: "GetMyMissionTrips",
    value: function () {
      var _GetMyMissionTrips = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        var showdonors, donors;
        return regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this._$resultsContainer.innerHTML = "";
                this._$loadingContainer.style.display = "";
                this._currentUrl = new URL(window.location.href);
                showdonors = this.getAttribute("showdonors");
                this._displayContacts = showdonors === "\"1\"" || showdonors === "1" ? true : false;
                _context6.next = 7;
                return this._missionTripsService.GetMyMissionTripDonors(this.missionTripCampaignType);

              case 7:
                donors = _context6.sent;

                this._missionTripsService.GetMyMissionTrips(this.missionTripCampaignType).then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(data) {
                    var elementMine, elementFamily, containerMyTrips, containerFamilyTrips, _loop, i, dtFormatter;

                    return regeneratorRuntime.wrap(function _callee4$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            data = data.filter(function (x) {
                              return x.pledgeStatusId !== 3 && x.pledgeStatusId !== 4;
                            });
                            _this3._$resultsContainer.innerHTML = "";
                            elementMine = document.createElement("div");
                            elementMine.innerHTML = data.length > 0 ? "<div class=\"myTripsContainer\" id=\"myTripsContainer\">\n\t\t\t\t\t\t<h1 class=\"mpp-mission-row-title\">".concat(_this3._i18n.pageTitle, "</h1>\n\t\t\t\t\t</div>") : "";

                            _this3._$resultsContainer.appendChild(elementMine);

                            _this3.myTripsContainerCount = 0;
                            elementFamily = document.createElement("div");
                            elementFamily.innerHTML = data.length > 0 ? "<div class=\"familyContainer\" id=\"familyContainer\">\n\t\t\t\t\t\t<h1 class=\"mpp-mission-row-title\">".concat(_this3._i18n.familyMissionTitle, "</h1>\n\t\t\t\t\t</div>") : "";

                            _this3._$resultsContainer.appendChild(elementFamily);

                            _this3.familyContainerCount = 0;
                            _this3._$myTripsContainer = _this3._root.querySelector("#myTripsContainer");
                            _this3._$familyTripsContainer = _this3._root.querySelector("#familyContainer");

                            if (!(data.length <= 0)) {
                              _context5.next = 18;
                              break;
                            }

                            // No pledges associated to user
                            _this3._$emptyContainer.style.display = "";
                            _this3._$emptyContainer.innerHTML += "<div id=\"myMissionTripsEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(_this3._i18n.noMissionTripsFoundMessage ? _this3._i18n.noMissionTripsFoundMessage : "No pledges found", "</span>\n\t\t\t\t\t\t</div>");
                            _this3._$loadingContainer.style.display = "none";
                            _context5.next = 33;
                            break;

                          case 18:
                            // Loop through each group and build page with cards
                            _this3._$emptyContainer.style.display = "none";
                            data = data.sort(function (a, b) {
                              return a.isMyMission - b.isMyMission;
                            });
                            containerMyTrips = "";
                            containerFamilyTrips = "";
                            _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                              var _data$i, campaignGoal, campaignName, contactEmailAddress, contactFirstName, contactLastName, contactNickname, contactFriendlyName, endDate, eventStartDate, eventEndDate, _data$i$firstInstallm, firstInstallmentDate, _data$i$imageUrl, imageUrl, installmentsPlanned, pledge, pledgeCampaignId, pledgeDescription, pledgeId, pledgeRemainingString, pledgeStatus, pledgeTotalToDate, pledgeTotalToDateString, progress, showOnMyPledges, startDate, totalPledge, totalPledgeString, tripLeader, isMyMission, pledgeOwner, myPledgeDescription, progressBarPercentage, progressBarText, badgeText, subtitlesArr, eventStart, eventEnd, tripDatesText, pledgeDonors, footerDetails, cardRow;

                              return regeneratorRuntime.wrap(function _loop$(_context4) {
                                while (1) {
                                  switch (_context4.prev = _context4.next) {
                                    case 0:
                                      _data$i = _objectSpread({}, data[i]), campaignGoal = _data$i.campaignGoal, campaignName = _data$i.campaignName, contactEmailAddress = _data$i.contactEmailAddress, contactFirstName = _data$i.contactFirstName, contactLastName = _data$i.contactLastName, contactNickname = _data$i.contactNickname, contactFriendlyName = _data$i.contactFriendlyName, endDate = _data$i.endDate, eventStartDate = _data$i.eventStartDate, eventEndDate = _data$i.eventEndDate, _data$i$firstInstallm = _data$i.firstInstallmentDate, firstInstallmentDate = _data$i$firstInstallm === void 0 ? dtFormatter.ToShortDateFormatted(firstInstallmentDate, true) : _data$i$firstInstallm, _data$i$imageUrl = _data$i.imageUrl, imageUrl = _data$i$imageUrl === void 0 ? imageUrl ? imageUrl : null : _data$i$imageUrl, installmentsPlanned = _data$i.installmentsPlanned, pledge = _data$i.pledge, pledgeCampaignId = _data$i.pledgeCampaignId, pledgeDescription = _data$i.pledgeDescription, pledgeId = _data$i.pledgeId, pledgeRemainingString = _data$i.pledgeRemainingString, pledgeStatus = _data$i.pledgeStatus, pledgeTotalToDate = _data$i.pledgeTotalToDate, pledgeTotalToDateString = _data$i.pledgeTotalToDateString, progress = _data$i.progress, showOnMyPledges = _data$i.showOnMyPledges, startDate = _data$i.startDate, totalPledge = _data$i.totalPledge, totalPledgeString = _data$i.totalPledgeString, tripLeader = _data$i.tripLeader, isMyMission = _data$i.isMyMission;
                                      dtFormatter = new DateTimeFormatter();
                                      pledgeOwner = contactFirstName + " " + contactLastName;

                                      if (pledgeOwner == "null null") {
                                        pledgeOwner = "";
                                      }

                                      myPledgeDescription = pledgeDescription == null ? "" : pledgeDescription;
                                      progressBarPercentage = 0;

                                      if (pledgeTotalToDate > 0) {
                                        progressBarPercentage = pledgeTotalToDate >= totalPledge ? "100" : Math.trunc(pledgeTotalToDate / totalPledge * 100);
                                      }

                                      progressBarText = pledgeTotalToDateString + " of " + totalPledgeString + " (" + progressBarPercentage + "%)";
                                      badgeText = _this3.GetBadgeText(tripLeader, pledgeStatus);
                                      subtitlesArr = CardBuilder.BuildGroupSubtitlesArr(pledgeOwner);
                                      eventStart = dtFormatter.ToShortDateFormatted(eventStartDate, true);
                                      eventEnd = new Date(eventEndDate).getYear() < 0 ? "" : " - " + dtFormatter.ToShortDateFormatted(eventEndDate, true);
                                      tripDatesText = new Date(eventStartDate).getYear() < 0 ? "Trip Date: " : "Trip Date: " + eventStart + eventEnd;
                                      pledgeDonors = donors.filter(function (x) {
                                        return x.pledgeId === data[i].pledgeId;
                                      });
                                      _context4.t0 = "<div class=\"mpp-card-row-details--header\">\n\t\t\t\t\t\t\t".concat(myPledgeDescription === "" ? "" : new TextFormatter(myPledgeDescription).addLineBreaks(), "\n\t\t\t\t\t\t</div>") + _this3.BuildGoalSummary(pledgeTotalToDateString, totalPledgeString, pledgeRemainingString);
                                      _context4.next = 17;
                                      return _this3.BuildDonorGrid(pledgeDonors);

                                    case 17:
                                      _context4.t1 = _context4.sent;
                                      footerDetails = _context4.t0 + _context4.t1;
                                      // Build Card
                                      cardRow = CardBuilder.BuildCardRow( // Header
                                      CardBuilder.BuildBadge(true, badgeText, "mpp-card-row"), _this3.BuildImageRow(imageUrl, "heart"), campaignName, tripDatesText, // Body
                                      CardBuilder.BuildTextRow(subtitlesArr, "mpp-card-row") + CardBuilder.BuildProgressRow("My Support Progress", "I've Raised: ".concat(progressBarPercentage, "%"), progressBarPercentage), // Footer
                                      CardBuilder.BuildCardRowFooter(i, imageUrl, footerDetails));

                                      if (isMyMission == true) {
                                        _this3._$myTripsContainer.appendChild(cardRow);

                                        _this3.myTripsContainerCount++;
                                      } else {
                                        _this3._$familyTripsContainer.appendChild(cardRow);

                                        _this3.familyContainerCount++;
                                      }

                                    case 21:
                                    case "end":
                                      return _context4.stop();
                                  }
                                }
                              }, _loop);
                            });
                            i = 0;

                          case 24:
                            if (!(i < data.length)) {
                              _context5.next = 29;
                              break;
                            }

                            return _context5.delegateYield(_loop(i), "t0", 26);

                          case 26:
                            i++;
                            _context5.next = 24;
                            break;

                          case 29:
                            if (_this3.myTripsContainerCount == 0) {
                              _this3._$resultsContainer.removeChild(elementMine);
                            }

                            if (_this3.familyContainerCount == 0) {
                              _this3._$resultsContainer.removeChild(elementFamily);
                            }

                            if (_this3._$resultsContainer.innerHTML === "") {
                              _this3._$resultsContainer.innerHTML = _this3._i18n.noMissionTripsFoundMessage;
                            }

                            _this3._$loadingContainer.style.display = "none";

                          case 33:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }())["catch"](function (error) {
                  console.error(error);
                  _this3._$loadingContainer.style.display = "none";
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetMyMissionTrips() {
        return _GetMyMissionTrips.apply(this, arguments);
      }

      return GetMyMissionTrips;
    }()
  }, {
    key: "BuildGoalSummary",
    value: function BuildGoalSummary(pledgeTotalToDateString, totalPledgeString, PledgeRemainingString) {
      return "<div class=\"mpp-card-row-goal-container\">\n\t\t\t\t<div class=\"mpp-card-row-goal\">\n\t\t\t\t\t<div class=\"mpp-card-row-goal--header\">\n\t\t\t\t\t\tMy Support Goal\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-goal--amount\">\n\t\t\t\t\t\t".concat(totalPledgeString, "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mpp-card-row-goal\">\n\t\t\t\t\t<div class=\"mpp-card-row-goal--header\">\n\t\t\t\t\t\tAmount I've Raised\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-goal--amount\">\n\t\t\t\t\t\t").concat(pledgeTotalToDateString, "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mpp-card-row-goal\">\n\t\t\t\t\t<div class=\"mpp-card-row-goal--header\">\n\t\t\t\t\t\tAmount Remaining\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-goal--remaining\">\n\t\t\t\t\t\t").concat(PledgeRemainingString, "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>");
    }
  }, {
    key: "BuildDonorGrid",
    value: function () {
      var _BuildDonorGrid = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(pledgeDonors) {
        var donorGrid, i, imageUrlThumbnail;
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this._displayContacts === false)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return", "");

              case 2:
                donorGrid = "";

                if (pledgeDonors.length === 0) {
                  donorGrid = "<div class=\"mpp-donor-empty\">\n\t\t\t\t\tOnce people start donating, their contact information displays here so you can thank them for their support!\n\t\t\t\t</div>";
                } else {
                  donorGrid = "<div class=\"mpp-card-row-donor-grid--header\">\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--cell\">\n\t\t\t\t\t\tName\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--cell\">\n\t\t\t\t\t\tAddress\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--cell\">\n\t\t\t\t\t\tPhone\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--cell\">\n\t\t\t\t\t\tEmail\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mpp-card-row-donor-grid--records\">\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--container\">";

                  for (i = 0; i < pledgeDonors.length; i++) {
                    imageUrlThumbnail = pledgeDonors[i].imageUrl == "" ? "" : pledgeDonors[i].imageUrl + "?$thumbnail=true";
                    donorGrid += this.BuildDonor(i, imageUrlThumbnail, pledgeDonors[i].pledgeDonorDisplayName, pledgeDonors[i].addressLine1, pledgeDonors[i].addressLine2, pledgeDonors[i].city, pledgeDonors[i].stateRegion, pledgeDonors[i].postalCode, pledgeDonors[i].phone, pledgeDonors[i].email);
                  }

                  donorGrid += "</div></div>";
                }

                return _context7.abrupt("return", "<div class=\"mpp-card-row-donor--header\">\n\t\t\t\tMy Donors\n\t\t\t</div>\n\t\t\t<div class=\"mpp-card-row-donor--container\">" + donorGrid + "</div>");

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, this);
      }));

      function BuildDonorGrid(_x3) {
        return _BuildDonorGrid.apply(this, arguments);
      }

      return BuildDonorGrid;
    }()
  }, {
    key: "BuildDonor",
    value: function BuildDonor(index, imageUrl, donorName, donorAddress1, donorAddress2, donorCity, donorStateRegion, donorPostalCode, donorPhone, donorEmail) {
      var CityStateZip = donorCity == null || donorCity == "" ? "" : donorCity + ", " + donorStateRegion + " " + donorPostalCode;
      var donorAddress3 = donorAddress2 == null || donorAddress2 == "" ? "" : CityStateZip;
      donorAddress2 = donorAddress2 == null || donorAddress2 == "" ? CityStateZip : donorAddress2;
      var addressHeader = donorAddress1 == null || donorAddress1 == "" ? "" : "<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only\">\n\t\t\t\tAddress\n\t\t\t</div>";
      var donorAddress = "".concat(addressHeader, "\n\t\t\t<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only-value\">\n\t\t\t\t<div>").concat(donorAddress1, "</div>\n\t\t\t\t<div>").concat(donorAddress2, "</div>\n\t\t\t\t<div>").concat(donorAddress3, "</div>\n\t\t\t</div>");
      var phoneHeader = donorPhone == null || donorPhone == "" ? "" : "<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only\">\n\t\t\t\tPhone\n\t\t\t</div>";
      var donorPhoneNumberOnly = donorPhone.replace(/\D/g, "");
      var phoneValue = donorPhone == "--" ? donorPhone : "<a class=\"mpp-contact-cell\" \n\t\t\thref=\"tel:+".concat(donorPhoneNumberOnly, "\">").concat(donorPhone, "</a>");
      donorPhone = "".concat(phoneHeader, "\n\t\t\t<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only-value\">\n\t\t\t\t").concat(phoneValue, "\n\t\t\t</div>");
      var emailHeader = donorEmail == null || donorEmail == "" ? "" : "<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only\">\n\t\t\t\tEmail\n\t\t\t</div>";
      var emailValue = donorEmail == "--" ? donorEmail : "<a class=\"mpp-contact-cell\" \n\t\t\thref=\"mailto:".concat(donorEmail, "\">").concat(donorEmail, "</a>");
      donorEmail = "".concat(emailHeader, "\n\t\t\t<div class=\"mpp-card-row-donor-grid--cell mpp-mobile-only-value\">\n\t\t\t\t").concat(emailValue, "\n\t\t\t</div>");
      var altRow = index % 2 == 1 ? "mpp-alt-row" : "";
      var divider = index == 0 ? "" : "mpp-card-row-donor-row--divider";
      var tempImage = this.BuildImageRow(imageUrl, "household-member", "mpp-thumbnail");
      return "<div class=\"mpp-card-row-donor-grid--row ".concat(altRow, " ").concat(divider, "\">\n\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--cell mpp-image-cell\">\n\t\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--item\">") + tempImage + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mpp-card-row-donor-grid--item mpp-spacer-left\">".concat(donorName, "</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t").concat(donorAddress, "\n\t\t\t\t\t").concat(donorPhone, "\n\t\t\t\t\t").concat(donorEmail, "\n\t\t\t\t</div>");
    }
  }, {
    key: "BuildImageRow",
    value: function BuildImageRow(imageUrl, type) {
      var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "mpp-card-row--image";
      var src = imageUrl;
      var returnDiv = "";

      if (imageUrl === null || imageUrl === undefined || imageUrl === "") {
        if (type === "household-member") {
          src = "".concat(this._appRoot, "/Content/icons/icon-").concat(type, ".svg");
          returnDiv = "<div class=\"mpp-no-image\">\n\t\t\t\t\t<img class=\"mpp-card-row-no-thumbnail\" src=\"".concat(src, "\" />\n\t\t\t\t</div>");
        } else {
          returnDiv = "<div class=\"mpp-card-row--no-image\">\n\t\t\t\t\t</div>";
        }
      } else {
        returnDiv = "<img class=\"".concat(className, "\" src=\"").concat(src, "\"/>");
      }

      return returnDiv;
    }
  }, {
    key: "GetBadgeText",
    value: function GetBadgeText(tripLeader, pledgeStatus) {
      var badgeText = "";
      var pledgeStatusLabel = !!pledgeStatus ? PledgeUtils.mapPledgeStatusToAppLabel(pledgeStatus, this._i18n) : "";

      if (!!tripLeader) {
        badgeText = this._i18n.leaderLabel;

        if (!!pledgeStatusLabel) {
          badgeText += " / " + pledgeStatusLabel;
        }
      } else if (!!pledgeStatusLabel) {
        badgeText = pledgeStatusLabel;
      }

      return badgeText;
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Mission Trips",
        tag: "mpp-my-mission-trips",
        configurationItems: [{
          name: "Mission Trip Campaign Type ID",
          attribute: "missiontripcampaigntypeid",
          description: "Determines the Campaign Type ID of Pledge Campaigns which will be eligible to appear in My Mission Trips.",
          required: true,
          type: "foreignkey",
          fkTable: "Pledge_Campaign_Types",
          fkFilter: "",
          fkSingleName: "Campaign Type"
        }, {
          name: "Show Donors",
          attribute: "showdonors",
          description: "Choose whether or not to show donor information on this mission trip.",
          required: false,
          type: "list",
          listValues: [{
            label: "True",
            value: 1
          }, {
            label: "False",
            value: 0
          }]
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["missiontripcampaigntypeid"];
    }
  }]);

  return MppMyMissionTrips;
}(ComponentBase);
MppMyMissionTrips.registerComponent(MppMyMissionTrips.WidgetDetails.tag, MppMyMissionTrips);